<div fxLayout="row" class="background">
  <div fxFlex="80" fxFlexOffset="10%">
    <div>
      <button mat-stroked-button color="warn">Cerrar Ahora</button>
    </div>
    <section id="header">
      <h1 class="h1Header">AGREGAR PRODUCTO</h1>
    </section>

    <form [formGroup]="addProductForm" (ngSubmit)="saveChanges(addProductForm.value)">
      <mat-card>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
          <div fxFlex="50">
            <mat-form-field appearance="outline">
              <mat-label>Categoría</mat-label>
              <mat-select formControlName="categoria" required>
                <mat-option *ngFor="let option of allCategories" [value]="option.id">
                  {{option.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div fxFlex="50">
            <mat-form-field appearance="outline">
              <mat-label>Nombre</mat-label>
              <input type="text" matInput formControlName="nombre" [value]="addProductForm.controls['nombre'].value | titlecase" required>
              <mat-error *ngIf="addProductForm.controls['nombre'].hasError('required')">
                Este campo es obligatorio
              </mat-error>              
              <mat-error *ngIf="addProductForm.controls['nombre'].hasError('cannotContainSpace')">
                El nombre no puede ser un espacio en blanco
              </mat-error>
              <mat-error *ngIf="addProductForm.controls['nombre'].hasError('startWithSpace')">
                El nombre no puede empezar en blanco
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
          <div fxFlex="100">
            <mat-form-field appearance="outline">
              <mat-label>Descripción</mat-label>
              <input type="text" matInput formControlName="descripcion" [value]="addProductForm.controls['descripcion'].value | titlecase" required>
              <mat-error *ngIf="addProductForm.controls['descripcion'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
              <mat-error *ngIf="addProductForm.controls['descripcion'].hasError('cannotContainSpace')">
                El nombre no puede ser un espacio en blanco
              </mat-error>
              <mat-error *ngIf="addProductForm.controls['descripcion'].hasError('startWithSpace')">
                El nombre no puede empezar en blanco
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
          <div fxFlex="50">
            <mat-form-field appearance="outline">
              <mat-label>Estado</mat-label>
              <mat-select formControlName="estado" required>
                <mat-option *ngFor="let option of status" [value]="option.value">
                  {{option.viewValue}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div fxFlex="50">
            <mat-form-field appearance="outline">
              <mat-label>Imagen</mat-label>
              <ngx-mat-file-input formControlName="imagen" accept=".png, .jpg, .jpeg">
              </ngx-mat-file-input>
              <mat-error *ngIf="addProductForm.controls['imagen'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
          <div fxFlex="100">
            <mat-form-field appearance="outline">
              <mat-label>Orden</mat-label>
              <input type="number" matInput formControlName="orden" required>
              <mat-error *ngIf="addProductForm.controls['orden'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
          <div fxFlex="33">
            <mat-form-field appearance="outline">
              <mat-label>Texto Pequeño(opcional)</mat-label>
              <input type="text" matInput formControlName="textP">
            </mat-form-field>
          </div>
          <div fxFlex="33">
            <mat-form-field appearance="outline">
              <mat-label>Texto Mediano</mat-label>
              <input type="text" matInput formControlName="textM" required>
              <mat-error *ngIf="addProductForm.controls['textM'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
              <mat-error *ngIf="addProductForm.controls['textM'].hasError('cannotContainSpace')">
                El nombre no puede ser un espacio en blanco
              </mat-error>
              <mat-error *ngIf="addProductForm.controls['textM'].hasError('startWithSpace')">
                El nombre no puede empezar en blanco
              </mat-error>
            </mat-form-field>
          </div>
          <div fxFlex="33">
            <mat-form-field appearance="outline">
              <mat-label>Texto Grande(opcional)</mat-label>
              <input type="text" matInput formControlName="textG">
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
          <div fxFlex="33">
            <mat-form-field appearance="outline">
              <mat-label>Precio Pequeño(opcional)</mat-label>
              <input type="number" matInput formControlName="precioP">
            </mat-form-field>
          </div>
          <div fxFlex="33">
            <mat-form-field appearance="outline">
              <mat-label>Precio Mediano</mat-label>
              <input type="number" matInput formControlName="precioM" required>
              <mat-error *ngIf="addProductForm.controls['precioM'].hasError('required')">
                Este campo es obligatorio
              </mat-error>
              <mat-error *ngIf="addProductForm.controls['precioM'].hasError('min')">
                El precio debe ser mayor a 0.
              </mat-error>
            </mat-form-field>
          </div>
          <div fxFlex="33">
            <mat-form-field appearance="outline">
              <mat-label>Precio Grande(opcional)</mat-label>
              <input type="number" matInput formControlName="precioG">
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="0.5rem">
          <mat-slide-toggle formControlName="banner">
            <span class="slide">Agregar a banner</span>
          </mat-slide-toggle>
        </div>
      </mat-card>
      <br>
      <div fxLayout="row" fxLayoutAlign="start center">
        <button type="submit" mat-raised-button class="save-changes" [disabled]="!addProductForm.valid">GUARDAR CAMBIOS</button>
        <button routerLink="/product-management" mat-raised-button class="cancel-changes">CANCELAR</button>
      </div>
    </form>
  </div>
</div>
